var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "sz19ryngqa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.576471 0 0 0 0 0.835294 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-398 -108) translate(-1 85)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M3.164.277C4.897-.341 6.831.094 8.131 1.395c1.3 1.301 1.735 3.235 1.116 4.968L24 21.115 21.113 24 6.36 9.25c-1.733.617-3.667.182-4.967-1.12C.094 6.83-.341 4.897.278 3.164l3.041 3.043c.512.53 1.271.743 1.985.557.713-.187 1.27-.744 1.457-1.457.186-.714-.026-1.472-.557-1.985L3.163.276h.001zM17.266 2.84L21.594.435l1.924 1.923-2.405 4.329-2.405.481-2.884 2.885L13.9 8.13l2.885-2.885.482-2.405zM7.648 13.42l2.885 2.886-6.734 6.734c-.77.763-2.005.79-2.808.06-.803-.73-.894-1.961-.207-2.801l.132-.146 6.733-6.733h-.001z",
    transform: "translate(399 23)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsTools);
export default __webpack_public_path__ + "static/media/icons-tools.3cd02d7211176320b23d64bdc032815c.svg";
export { ForwardRef as ReactComponent };